<template>
  <v-container>
    <v-card color="">
      <v-card-title style="color: #B08836"  class="font-weight-bold">
        <h2 class="heading font-weight-bold">{{formTitle}}</h2>
        <v-spacer></v-spacer>
        <v-btn color="#0A4A79" dark to="/panel" small>
          <v-icon small class="mr-5">mdi-arrow-left</v-icon>
          Ir a Panel
        </v-btn>
      </v-card-title>
      <v-divider inset></v-divider>
      <v-card-text>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="">
              <v-autocomplete
                v-model="salaSelected"
                :items="salasList"
                dense
                item-text="nombre"
                item-value="id"
                return-object
                label="Selecciona Área"
                prepend-icon="mdi-gavel"
                outlined
                @change="cleanSalaSelected()"
                persistent-hint
                no-data-text="No se Encontraron Áreas"
                required
                :rules="[v => !!v|| 'Seleccione el Área']"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mt-n7">
            <v-col v-if="salaSelected == '' || salaSelected.id <= 11" cols="12" sm="5">
              <v-text-field
              outlined
              dense
              v-model="toca"
              label="Número de Toca"
              prepend-icon="mdi-folder"
              min='1'
              placeholder="1234/2021 o L1234/2021"
              :rules="tocaRules"
              >
              </v-text-field>
            </v-col>
            <v-col v-if="salaSelected.id == 12" cols="12" md="5">
              <v-text-field
                dense
                v-model.trim="expediente"
                label="Asunto Laboral"
                prepend-icon="mdi-folder"
                outlined
                required
                placeholder="1234/2021"
                :rules="expedienteRules"
              ></v-text-field>
            </v-col>
            <v-col v-if="salaSelected.id == 13" cols="12" md="12">
              <v-text-field
                dense
                v-model.trim="asunto"
                label="Asunto"
                prepend-icon="mdi-message-text"
                outlined
                required
                :rules="[v => !!v|| 'Este campo es requerido']"
              ></v-text-field>
            </v-col>
          </v-row>
          </v-form>
          <!-- Fin form crear -->

          <v-row>
            <v-col class="" align="center">
               <h3>BAJO PROTESTA DE DECIR VERDAD, ADJUNTO LOS SIGUIENTES DOCUMENTOS</h3>
            </v-col>
          </v-row><br>

          <!-- form firmar documento -->
          <v-form @submit.prevent="save" ref="evidencia" v-model="validEvidencia" lazy-validation>
          <v-card outlined rounded="lg" elevation="1" class="mt-2">
            <v-card-text class="pb-4">
              <!-- Header -->
              <div class="d-flex align-center flex-wrap mb-1">
                <v-icon color="#0A4A79" class="mr-2">mdi-file-certificate-outline</v-icon>
                <span class="font-weight-bold" style="color:#0A4A79; font-size:15px; letter-spacing:0.2px;">Firmar Documento</span>
                <v-spacer></v-spacer>
                <span class="caption grey--text text--darken-1">PDF / DOC • Máx. 20 MB</span>
              </div>
              <v-divider class="mb-4"></v-divider>

              <div class="text-center mb-3">
                <span class="font-weight-medium" style="color:#333;">
                  <span v-if="salaSelected.id <= 11">Subir el escrito de la promoción</span>
                  <span v-else-if="salaSelected.id == 12">Subir el Asunto Laboral</span>
                  <span v-else-if="salaSelected.id == 13">Subir el Documento</span>
                  <span v-else>Subir el documento a firmar</span>
                </span>
              </div>

              <v-file-input
                v-model="file_promocion"
                color="#0A4A79"
                :label="salaSelected.id <= 11 ? 'Selecciona Promoción' : 'Selecciona Documento'"
                prepend-icon="mdi-paperclip"
                outlined
                dense
                show-size
                :clearable="false"
                accept="application/pdf, .doc, .docx"
                truncate-length="50"
                hint="Formatos permitidos: PDF, DOC, DOCX"
                persistent-hint
                hide-details="auto"
                class="mb-1"
                :rules="fileRules"
                @change="SelccionarArchivo($event)"
                :disabled="archivo.encode != ''"
              ></v-file-input>

              <v-divider class="my-5"></v-divider>

              <!-- Opciones de firma - mismo acomodo 6/6 pero con cards internas - siempre visibles, disabled tras firmar como en contestacion -->
              <v-row dense>
                <!-- Firel -->
                <v-col cols="12" md="6">
                  <v-card outlined rounded="lg" class="pa-3 h-100" style="border-color:#E0E0E0;">
                    <div class="d-flex align-center mb-3">
                      <v-avatar size="28" color="#FFF8E1" class="mr-2"><v-icon small color="#F9A825">mdi-certificate-outline</v-icon></v-avatar>
                      <span class="font-weight-bold" style="color:#0A4A79;">Firma Firel</span>
                      <v-spacer></v-spacer>
                      <span class="caption grey--text">.pfx</span>
                    </div>
                    <v-file-input
                      v-model="file_firel"
                      color="#0A4A79"
                      label="Seleccionar archivo .pfx"
                      prepend-icon="mdi-certificate"
                      outlined
                      dense
                      show-size
                      hide-details="auto"
                      hint="Archivo PFX de tu Firel"
                      persistent-hint
                      accept=".pfx"
                      truncate-length="30"
                      @change="SeleccionarPfx($event)"
                      :disabled="archivo.encode != ''"
                      class="mb-3"
                    ></v-file-input>
                    <v-text-field
                      v-model="password"
                      label="Contraseña Firel"
                      placeholder="Ingresa tu contraseña"
                      prepend-icon="mdi-lock-outline"
                      :type="showpass ? 'text' : 'password'"
                      :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showpass = !showpass"
                      outlined
                      dense
                      hide-details="auto"
                      :disabled="archivo.encode != ''"
                      class="mb-3"
                    ></v-text-field>
                    <div class="d-flex justify-start mt-4" style="margin-left: 32px;">
                      <v-btn
                        small
                        :depressed="!(!activarBoton || (file_promocion && file_promocion.size && file_promocion.size > 20971520))"
                        :outlined="!!(!activarBoton || (file_promocion && file_promocion.size && file_promocion.size > 20971520))"
                        :loading="loadingFirma"
                        :disabled="!activarBoton || (file_promocion && file_promocion.size && file_promocion.size > 20971520)"
                        :color="(!activarBoton || (file_promocion && file_promocion.size && file_promocion.size > 20971520)) ? 'grey' : '#0A4A79'"
                        :dark="!(!activarBoton || (file_promocion && file_promocion.size && file_promocion.size > 20971520))"
                        :class="(!activarBoton || (file_promocion && file_promocion.size && file_promocion.size > 20971520)) ? '' : 'white--text'"
                        class="px-6"
                        style="min-width: 152px;"
                        @click="firmar()"
                      >
                        <v-icon small left :color="(!activarBoton || (file_promocion && file_promocion.size && file_promocion.size > 20971520)) ? '' : 'white'">mdi-draw</v-icon> FIRMAR FIREL
                      </v-btn>
                    </div>
                  </v-card>
                </v-col>

                <!-- eFirma SAT -->
                <v-col cols="12" md="6">
                  <v-card outlined rounded="lg" class="pa-3 h-100" style="border-color:#E0E0E0;">
                    <div class="d-flex align-center mb-3">
                      <v-avatar size="28" color="#E3F2FD" class="mr-2"><v-icon small color="#0A4A79">mdi-key-variant</v-icon></v-avatar>
                      <span class="font-weight-bold" style="color:#0A4A79;">Firma eFirma (SAT)</span>
                      <v-spacer></v-spacer>
                      <span class="caption grey--text">.key + .cer</span>
                    </div>
                    <v-file-input
                      v-model="key"
                      color="#0A4A79"
                      label="Archivo .key"
                      prepend-icon="mdi-key"
                      outlined
                      dense
                      accept=".key"
                      hide-details="auto"
                      hint="Clave privada"
                      persistent-hint
                      truncate-length="30"
                      @change="SeleccionarKey($event)"
                      :disabled="archivo.encode != ''"
                      class="mb-3"
                    ></v-file-input>
                    <v-file-input
                      v-model="cert"
                      color="#0A4A79"
                      label="Archivo .cer"
                      prepend-icon="mdi-certificate-outline"
                      outlined
                      dense
                      accept=".cer"
                      hide-details="auto"
                      hint="Certificado"
                      persistent-hint
                      truncate-length="30"
                      @change="SeleccionarCer($event)"
                      :disabled="archivo.encode != ''"
                      class="mb-3"
                    ></v-file-input>
                    <v-text-field
                      v-model="password2"
                      label="Contraseña eFirma"
                      placeholder="Contraseña de clave privada"
                      prepend-icon="mdi-lock-outline"
                      :type="showpass2 ? 'text' : 'password'"
                      :append-icon="showpass2 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showpass2 = !showpass2"
                      outlined
                      dense
                      hide-details="auto"
                      :disabled="archivo.encode != ''"
                      class="mb-3"
                    ></v-text-field>
                    <div class="d-flex justify-start mt-4" style="margin-left: 32px;">
                      <v-btn
                        small
                        :depressed="!(!activarBoton2 || (file_promocion && file_promocion.size && file_promocion.size > 20971520))"
                        :outlined="!!(!activarBoton2 || (file_promocion && file_promocion.size && file_promocion.size > 20971520))"
                        :loading="loadingeFirma"
                        :disabled="!activarBoton2 || (file_promocion && file_promocion.size && file_promocion.size > 20971520)"
                        :color="(!activarBoton2 || (file_promocion && file_promocion.size && file_promocion.size > 20971520)) ? 'grey' : '#0A4A79'"
                        :dark="!(!activarBoton2 || (file_promocion && file_promocion.size && file_promocion.size > 20971520))"
                        :class="(!activarBoton2 || (file_promocion && file_promocion.size && file_promocion.size > 20971520)) ? '' : 'white--text'"
                        class="px-6"
                        style="min-width: 152px;"
                        @click="firmarSat()"
                      >
                        <v-icon small left :color="(!activarBoton2 || (file_promocion && file_promocion.size && file_promocion.size > 20971520)) ? '' : 'white'">mdi-draw-pen</v-icon> FIRMAR eFIRMA
                      </v-btn>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <v-expand-transition>
                <div v-if="archivo.file_name" class="mt-4">
                  <v-alert
                    dense
                    prominent
                    border="left"
                    colored-border
                    color="success"
                    elevation="1"
                    class="mb-0"
                    icon="mdi-check-decagram"
                  >
                    <div class="d-flex flex-column flex-sm-row align-stretch align-sm-center justify-space-between" style="gap:12px;">
                      <div class="d-flex flex-column flex-sm-row align-start align-sm-center flex-wrap" style="gap:10px; flex:1 1 auto; min-width:0;">
                        <span class="font-weight-bold d-flex align-center flex-wrap" style="color:#0A4A79; font-size:15px; gap:6px; word-break:break-word; white-space:normal;">
                          <!-- <v-icon small color="success" style="flex-shrink:0;">mdi-check-decagram</v-icon> -->
                          <span style="word-break:break-word;">Evidencia generada correctamente:</span>
                        </span>
                        <span class="font-weight-medium d-flex align-center flex-wrap" style="color:#1B1B1B; font-size:14.5px; gap:6px; min-width:0; word-break:break-word; overflow-wrap:anywhere;">
                          <img src="@/assets/img/file-pdf.svg" width="26" height="26" style="cursor:pointer; flex-shrink:0;" @click="saveTextAsFile()" alt="PDF" />
                          <span style="word-break:break-all; overflow-wrap:anywhere; min-width:0;">{{ archivo.file_name }}.pdf</span>
                          <v-icon small color="success" style="flex-shrink:0;">mdi-check-circle</v-icon>
                          <v-btn small depressed color="primary" class="flex-shrink-0" style="white-space:nowrap;" @click="saveTextAsFile()">
                            <v-icon small left>mdi-file-eye-outline</v-icon> Ver evidencia
                          </v-btn>
                        </span>
                      </div>
                    </div>
                  </v-alert>
                </div>
              </v-expand-transition>
            </v-card-text>
          </v-card>
          <div class="mt-4"></div>
          </v-form>
          <!-- fin form firmar documento -->

          <!-- form agregar documentos anexos -->
          <v-form @submit.prevent="save" ref="archivos" v-model="validArchivos" lazy-validation>
          <v-card v-if="salaSelected.id <= 11">
          <v-row class="mt-n2">
            <v-col cols="12">
              <p class="font-weight-black" align="center">Anexar Documentos</p>
            </v-col>
          </v-row>
          <v-row class="mt-n7">
            <!-- <v-col cols="12" md="5">
              <v-text-field
                v-model="nombre_documento"
                dense
                outlined
                class="mb-n4"
                label="Nombre Documento"
              >
              </v-text-field>
            </v-col> -->
            <v-col cols="12" md="7">
              <v-file-input
                v-model="files"
                color="blue darken-2"
                label="Seleccionar Archivo PDF"
                prepend-icon="mdi-paperclip"
                outlined
                dense
                show-size
                truncate-length="50"
                :rules="fileRules"
                accept="application/pdf"
              ></v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                v-model="tipo_documento"
                :items="ListTipoDocumento"
                item-text="nombre"
                return-object
                label="Tipo de Documento"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="2">
              <v-btn depressed color="primary" @click="fileSelected(files, 1)" :disabled="validateDocumento">AGREGAR</v-btn>
            </v-col>
          </v-row><br>

          <v-row class="mt-n6 ml-7">
            <v-col cols="12" v-if="documentos.length >=1 ">
              <p class="font-weight-black" align="left">Documentos Anexados</p>
            </v-col>
            <v-col class="mt-n7">
              <ul>
                <li v-for="item in documentos">
                  {{ item.file_name }} - {{item.tipo_documento_nombre}}
                   <v-icon
                    color="red"
                    @click="removeItem(item)"
                  >mdi-close</v-icon>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card><br>
        </v-form>
        <!-- fin form documentos anexos -->
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4" style="background:#FAFAFA; min-height:64px;">
        <v-spacer></v-spacer>
        <v-btn
          id="btn-enviar-unico"
          key="btn-enviar-unico"
          v-show="true"
          depressed
          :loading="loading"
          :disabled="!valid || !sign || !salaSelected || !salaSelected.id"
          :color="valid && sign && salaSelected && salaSelected.id ? 'success' : '#EEEEEE'"
          class="btn-enviar-custom px-6"
          :class="valid && sign && salaSelected && salaSelected.id ? 'white--text font-weight-bold' : ''"
          :dark="valid && sign && salaSelected && salaSelected.id"
          style="min-width:180px; letter-spacing:0.3px; opacity:1 !important; display:inline-flex !important; visibility:visible !important; border: 1px solid #BDBDBD;"
          @click="validate"
        >
          <v-icon left :color="valid && sign && salaSelected && salaSelected.id ? 'white' : 'rgba(0,0,0,0.45)'">
            mdi-content-save
          </v-icon>
          <span :style="valid && sign && salaSelected && salaSelected.id ? 'color:#FFFFFF !important; font-weight:600;' : 'color:rgba(0,0,0,0.45) !important; font-weight:400;'">
            {{ !salaSelected || !salaSelected.id || salaSelected.id <= 11 ? 'Enviar Promoción' : salaSelected.id == 12 ? 'Enviar Asunto' : 'Enviar Documento' }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import {SelectFileSign,message,SelectPfx,OpenPfx,PKCS7creado,extFileUpload} from '@/services/cliente';
import {SelectFileSigneFirma, SelectKEY, SelectCER, validateKeyPairs, FirmarEfirma, messageeFirma, PKCS7creadoeFirma, extFileUploadeFirma } from '@/services/eFirma';
import { CertificateRequest } from '@/services/clasesFirma';
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  export default {
    data(){
      return {
        pkcs7:'',
        dialogPdf: false,
        activarBoton: false,
        activarBoton2: false,
        filePFXselct: false,
        fileKEYselct: false,
        fileCERselct: false,
        message:'',
        messageeFirma:'',
        extArchivoCargado:'',
        extArchivoCargadoeFirma:'',
        file_firel: [],
        password:'',
        password2:'',
        showpass: false,
        showpass2: false,
        loading: false,
        loadingFirma: false,
        loadingeFirma: false,
        valid: true,
        validEvidencia: true,
        validArchivos: true,
        toca:'',
        expediente:'',
        asunto:'',
        numero:'',
        derivado:'',
        periodo:'',
        municipioSelected:'',
        salaSelected:'',
        descripcion: '',
        abogado_id: '',
        salasList:[],
        file_promocion:[],
        filesPromocion:[],
        nombre_documento:'',
        tipo_documento:'',
        files:[],
        documentos:[],
        archivo:{
          encode:'',
          type:'application/pdf',
          file_name:'',
          size:''
        },
        creaevidencia:true,
        sign:false,
        user:'',
        key:[],
        cert:[],
        password:'',
        validateDocumento: true,
        tocaRules: [
          v => !!v.trim().length || 'Ingrese el Número de Toca',
          v => /^(L)?(\d+)(\/)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato valido',
        ],
        expedienteRules: [
          v => !!v|| 'Ingrese el Número de Asunto Laboral',
          v => /^(\d+)(\/)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato valido'
        ],
        // numberRules: [v => !!v || 'Este campo es requerido',
        //               v => /^([1-9][0-9]*)*$/.test(v)  || 'El Toca no debe iniciar con cero'],
        // periodoRules: [
        //                v => ( v >= 1900 ) || 'El año no puede ser menor  al año 1900',
        //                v => ( v <= new Date().getFullYear() ) || 'El año no puede ser mayor al año actual',
        //               ],
        fileRules: [
          value => !value || value.size < 20971520 || 'El documento no debe exceder de 20MB!',
          // v => !v || 'El Campo es Requerido',
        ],
        ListTipoDocumento: [{id :'1', nombre:'Original'},{id :'2', nombre:'Copia Simple'}, {id :'3', nombre:'Copia Certificada'}],
      }
    },
    computed: {
      formTitle () {
        if (this.salaSelected.id === 12) {
          return 'Nuevo Asunto Laboral'
        }else if (this.salaSelected.id === 13) {
          return 'Buzón Presidencia'
        }
        return 'Nueva Promoción'
      },
      ...mapGetters([
        "currentUser",
        "listSalas",
        "roleUser",
        // "listMunicipios"
      ]),
    },
    watch: {
      files: function (val) {
        if(val && (!this.tipo_documento || val.size > 20971520)){
          this.validateDocumento = true
        }
        else if (!val) {
          this.validateDocumento = true
        }
        else {
          this.validateDocumento = false
        }
      },
      tipo_documento: function (val) {
        if(val && (!this.files || !this.files.name || this.files.size > 20971520)){
          this.validateDocumento = true
        }
        else if (!val) {
          this.validateDocumento = true
        }
        else {
          this.validateDocumento = false
        }
      },
    },
    mounted() {
      // this.getMunicipios();
      this.getSalas();
    },
    methods:{
      //Metodos Firel
      SelccionarArchivo(file) {
        
        if(file === undefined){
           this.activarBoton = false;
           this.activarBoton2 = false;
          return false;  
        }
          SelectFileSign(file).then((isValidFile)=>{
          if(isValidFile){
                this.message=message;
                this.extArchivoCargado=extFileUpload;
                if(this.filePFXselct != ""){
                   this.activarBoton = true;
                }
                 
                if(this.fileKEYselct != ''){
                   this.activarBoton2 = true;
                   SelectCER(this.cert);
                }
            }
         });

         SelectFileSigneFirma(file).then((isValidFile) => {
         
              if (isValidFile) {
                  this.messageeFirma = messageeFirma;
                  this.extArchivoCargadoeFirma = extFileUploadeFirma;
                  
              }
              
          });
      },
      SeleccionarPfx(filePFX) {
        if(filePFX === null){
          this.filePFXselct = '';
          this.activarBoton =false;
          return false;
        }
        this.filePFXselct=filePFX;
        this.activarBoton=SelectPfx(filePFX);
        // if(this.activarBoton){
        //     this.filePFXselct=filePFX;
        // }
      },
      firmar() {
        OpenPfx(this.filePFXselct,this.password).then((isCreatePKCS7)=>{
            if(isCreatePKCS7){
                var fecha = new Date();
                this.pkcs7=PKCS7creado;
                this.FileName = "pkcs7_" + fecha.valueOf() + "." + this.extArchivoCargado;
                this.creaEvidencia(this.pkcs7);
            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Archivo PFX o contraseña invalida, Favor de Verificar',
                confirmButtonText: "Aceptar",
              })
            }
         });
      },

      // metodos eFIRMA
      SeleccionarKey(filePFX) {
        
        if (SelectKEY(filePFX)) {
              this.fileKEYselct = filePFX;
                 if(this.message != '' && this.fileCERselct != false){
                         this.activarBoton2 = true;
                         }
          }else{
             this.fileKEYselct = "";
             this.activarBoton2 = false;
          }
      },
      SeleccionarCer(fileCER) {
        
        if(fileCER === null){
          this.activarBoton2 = false;
          return false;
        }

          this.fileCERselct = fileCER;
               
          if(this.message != ''){
             this.activarBoton2 = true;
             SelectCER(fileCER);
             
          }else{
            this.activarBoton2 = false;
          }
          
          
          // SelectCER(fileCER).then((isValidFile) => {
            // this.activarBoton2=SelectCER(fileCER);
            // if (this.activarBoton2) {
            //       this.fileCERselct = fileCER;
            // }
          // });
      },

      firmarSat() {
          if (this.password2) {
              //Validacion de llaves
              let validacion = false;
              let privateKeyPem = '';
              validateKeyPairs(this.password2, function (e) {

                  if (e.state == 0) {
                      validacion = true;
                      privateKeyPem = e.privateKey;
                  }
                  else {
                    Swal.fire({
                      icon: 'warning',
                      title: e.description,
                      confirmButtonText: "Aceptar",
                    })
                      // alert(e.description);
                      validacion = false;
                  }
              });
              if (validacion) {
                  FirmarEfirma(privateKeyPem).then((isCreatePKCS7) => {
                      if (isCreatePKCS7) {
                          var fecha = new Date();
                          this.pkcs7 = PKCS7creadoeFirma;
                          this.FileName = "pkcs7_" + fecha.valueOf() + "." + this.extArchivoCargadoeFirma;
                          this.creaEvidencia(this.pkcs7);
                      }
                  });
              }
              else { this.password = ""; }
          }
          else {
            Swal.fire({
              icon: 'warning',
              title: 'Ingrese su contraseña de clave privada.',
              confirmButtonText: "Aceptar",
            })
              // alert("Ingrese su contraseña de clave privada.");
          }
      },

      creaEvidencia(pkcs7)
      {
          Swal.fire({
            title: 'Estableciendo comunicación',
            html: 'Generando Evidencia Criptográfica ...',
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              Swal.showLoading()
            },
          })
        this.creaevidencia=true;
        this.loadingFirma = true;
        this.loadingeFirma = true;
        // let archivos = this.pkcs7.nativeElement.files;
        if(pkcs7){
           CertificateRequest.CertificateType = 3;
           CertificateRequest.Pkcs7Original = this.pkcs7;
           CertificateRequest.FileName = this.FileName;
           CertificateRequest.UserName = "Eliminar";
           this.$store.dispatch("FIREL_FIRMA", { url: "promocion/firmar", data: CertificateRequest })
           .then(response => {
             Swal.close();
             // console.log(response.data);
             this.loadingFirma = false;
             this.loadingeFirma = false;
             if(!response.data.data.IsSuccess){
                    Swal.fire({
                     icon: 'error',
                     title: response.data.data.ErrorMessage,
                     confirmButtonText: "Aceptar",
                    //  timer: 4500,
                   })
                return false;
               }

            
             Swal.fire({
               icon: 'success',
               title: 'Promoción Firmada con Éxito',
               confirmButtonText: "Aceptar",
               timer: 1500,
             })
              this.archivo.encode = response.data.data.PdfBase64;
             var fecha = new Date();
             this.archivo.file_name = "evidencia_" + fecha.valueOf();
             this.sign = true;
             this.key = [];
             this.cert = [];
             this.file_firel = [];
             this.file_promocion = [];
             this.password = '';
             this.password2 = '';
             this.activarBoton = false;
             this.activarBoton2 = false;
             this.$refs.evidencia.resetValidation()
                        
           })
           .catch(err => {
             console.log(err);
             this.loadingeFirma = false;
             this.loadingFirma = false;
           });
        } else {
          this.creaevidencia=false;
        }
      },

      // getMunicipios() {
      //   this.$store.dispatch("GET_MUNICIPIOS",  { url: "/municipios" } ).then(response => {
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      // },

      getSalas() {
        this.salaSelected = ''
        this.$store.dispatch("GET_SALAS",  { url: "/salas",
        }).then(response => {
          // console.log(response.data);
          this.salasList = response.data.data.salas
        })
        .catch(err => {
          console.log(err);
        });
      },

      cleanSalaSelected() {
        if (this.salaSelected.id > 11) {
          this.toca = ''
        }
        if (this.salaSelected.id == 12) {
          this.asunto = ''
          this.$refs.form.resetValidation()
        }
        if (this.salaSelected.id == 13) {
          this.expediente = ''
          this.$refs.form.resetValidation()
        }
      },

      validate() {
        if (!this.$refs.form.validate()) {
          Swal.fire({
            icon: 'warning',
            title: 'Favor de verificar los campos Requeridos',
            confirmButtonText: "Aceptar",
          })
        }
        else if (!this.sign) {
          Swal.fire({
            icon: 'warning',
            title: 'Favor de Firmar Promoción',
            confirmButtonText: "Aceptar",
          })
        }
        // if (!this.documentos.length) {
        //   this.loading = false
        //   Swal.fire({
        //     icon: 'error',
        //     title: 'Favor de agregar documentos.',
        //   })
        //   return false;
        // }
        if (this.$refs.form.validate() && this.sign == true) { // producción
        // if (this.$refs.form.validate() && this.sign == false) { // pruebas
          this.loading = true
          if (this.salaSelected.id == 12) {
            this.saveExpediente()
          } else if (this.salaSelected.id == 13) {
            this.saveBuzon()
          } else {
            this.save()
          }
        }
      },

      saveExpediente() {
        var expediente = this.expediente
          expediente = expediente.split("/",3)
          this.numero = expediente[0];
          this.periodo = expediente[1];
          this.derivado = expediente[2];
        const escrito = {
          sala_id: this.salaSelected.id,
          numero: this.numero,
          periodo: this.periodo,
          derivado: this.derivado,
          abogado_id: this.currentUser.id,
          firma_id:'udhqiufqwuifjdj',
          expediente_file: this.archivo
        }
        this.$store.dispatch("SAVE_INITIAL_EXPEDIENTE",  { url: "/expediente", data: escrito } ).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Asunto Enviado',
            confirmButtonText: "Aceptar",
            timer: 1500,
          })
          this.$router.push('/panel')
        })
          .catch(err => {
            Swal.fire({
                icon: 'error',
                title: err.response.data.message,
              })
            this.loading = false
            console.log("el error de nuevo",err);
          });
      },

      saveBuzon() {
        const buzon = {
          sala_id: this.salaSelected.id,
          asunto: this.asunto,
          abogado_id: this.currentUser.id,
          firma_id:'udhqiufqwuifjdj',
          buzon_file: this.archivo
        }
        this.$store.dispatch("SAVE_INITIAL_BUZON",  { url: "/buzon", data: buzon } ).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Escrito Enviado',
            confirmButtonText: "Aceptar",
            timer: 1500,
          })
          this.$router.push('/panel')
        })
          .catch(err => {
            Swal.fire({
                icon: 'error',
                title: err.response.data.message,
              })
            this.loading = false
            console.log("el error de nuevo",err);
          });
      },

      save() {
        var toca = this.toca
          toca = toca.split("/",3)
          this.numero = toca[0];
          this.periodo = toca[1];
          this.derivado = toca[2];
        const promocion = {
          tipo:2,
          //solicitud_escrita: this.descripcion,
          sala_id: this.salaSelected.id,
          numero: this.numero,
          periodo: this.periodo,
          derivado: this.derivado,
          abogado_id: this.currentUser.id,
          firma_id:'huwgduiqgduyqwgd',
          files: this.documentos,
          promocion_file: this.archivo
        }
        this.$store.dispatch("SAVE_INITIAL_PROMOCION",  { url: "/promocion", data: promocion } ).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Promoción Enviada',
            confirmButtonText: "Aceptar",
            timer: 1500,
          })
          this.$router.push('/panel')
        })
          .catch(err => {
            Swal.fire({
                icon: 'error',
                title: err.response.data.message,
              })
            this.loading = false
            console.log("el error de nuevo",err);
          });
      },

      fileSelected(item, firma){
        var file = item;
        // if (firma == 2) {
        //   this.nombre_documento = "Promoción"
        //   // var url = "https://e-firma.stjjalisco.gob.mx/(S(sgj2pok3qcijclcysys53xjy))/Home/InicioSesion"
        //   // window.open(url, '_blank');
        // }
        this.getBase64(file).then(data => {
          var block = data.split(";");
          var realData = block[1].split(",")[1];
          this.documentos.push({
            nombre: this.nombre_documento,
            tipo_documento_nombre: this.tipo_documento.nombre,
            tipo_documento: this.tipo_documento.id,
            sign: firma,
            type: 'application/pdf',
            file_name: file.name.split(".pdf")[0],
            size: file.size,
            encode: realData
          });
          this.files = null
          this.nombre_documento = ''
          this.tipo_documento = ''
        });
      },
      // filePromocion(item,firma){
      //     // var url = "https://e-firma.stjjalisco.gob.mx/(S(sgj2pok3qcijclcysys53xjy))/Home/InicioSesion"
      //     // window.open(url, '_blank');
      //   this.sign = true;
      //   var file = this.file_promocion;
      //   this.getBase64(file).then(data => {
      //     this.filesPromocion.push(data);
      //     // console.log(data);
      //     this.FilesToUpload()
      //   });
      //   // Swal.fire({
      //   //   icon: 'success',
      //   //   title: 'Promoción Firmada',
      //   //   confirmButtonText: "Aceptar",
      //   //   timer: 1500,
      //   // })
      // },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          }
        });
      },

      saveTextAsFile() {
        var fileB64 = this.archivo.encode
        var fecha = new Date();
        let blob = this.b64toBlob(fileB64, 'application/pdf', 512);
        let fileNameToSaveAs = "evidencia_" + fecha.valueOf() + ".pdf";
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target' ,'_blank');
        // link.setAttribute('download', fileNameToSaveAs);
        document.body.appendChild(link);
        link.click();
      },

      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      // FilesToUpload() {
      //   if (this.filesPromocion.length) {
      //     this.filesPromocion.forEach(file => {
      //       var block = file.split(";");
      //       // Get the content type of the image
      //       var contentType = block[0].split(":")[1]; // In this case "jpg
      //       // get the real base64 content of the file
      //       this.archivo['type'] = contentType
      //       var realData = block[1].split(",")[1];
      //       // console.log(realData);
      //       this.archivo['encode'] = realData
      //       this.archivo['file_name'] = this.file_promocion.name.split(".pdf")[0];
      //       // console.log(this.archivo);
      //     });
      //   }
      // },
      clearEvidencia(){
        this.archivo = { encode:'', type:'application/pdf', file_name:'', size:'' };
        this.sign = false;
        this.file_firel = [];
        this.key = [];
        this.cert = [];
        this.fileKEYselct = false;
        this.fileCERselct = false;
        this.filePFXselct = false;
        this.activarBoton = false;
        this.activarBoton2 = false;
        this.password = '';
        this.password2 = '';
        if(this.$refs.evidencia) this.$refs.evidencia.resetValidation();
      },
      removeItem(item){
        // if (item.sign==2) this.file_promocion = null
        this.documentos.splice(this.documentos.indexOf(item), 1);
      },
    }
  }
</script>

<style scoped>
.btn-enviar-custom.v-btn--disabled {
  opacity: 1 !important;
  background-color: #EEEEEE !important;
  color: rgba(0, 0, 0, 0.45) !important;
  border: 1px solid #BDBDBD !important;
}
.btn-enviar-custom.v-btn--disabled ::v-deep .v-icon,
.btn-enviar-custom.v-btn--disabled ::v-deep .v-btn__content {
  color: rgba(0, 0, 0, 0.45) !important;
  font-weight: 400 !important;
  opacity: 1 !important;
}
</style>
<style>
.btn-enviar-custom.v-btn.v-btn--disabled {
  opacity: 1 !important;
  background-color: #EEEEEE !important;
  color: rgba(0, 0, 0, 0.45) !important;
  border: 1px solid #BDBDBD !important;
}
.btn-enviar-custom.v-btn.v-btn--disabled .v-icon,
.btn-enviar-custom.v-btn.v-btn--disabled .v-btn__content {
  color: rgba(0, 0, 0, 0.45) !important;
  font-weight: 400 !important;
  opacity: 1 !important;
}
</style>
